import { Shield, Ban } from "lucide-react";

export function FooterStrip() {
  return (
    <div className="flex items-center justify-between border-t border-border px-4 py-2 text-[11px] text-muted-foreground">
      {/* Version deliberately not shown publicly — reduces fingerprinting
          surface on the public login page. Backend still exposes it via
          /api/health for authenticated operators. */}
      <span>Dravian Horizon</span>
      <div className="flex items-center gap-4">
        <span className="flex items-center gap-1.5"><Shield className="h-3 w-3" /> Self-Hosted</span>
        <span className="flex items-center gap-1.5"><Ban className="h-3 w-3" /> Zero Data Egress</span>
      </div>
    </div>
  );
}